import StreakDisplay from "../streak-display/streak-display.tsx";
import RaindropButton, {
  ButtonStyle,
} from "../raindrop-button/raindrop-button.tsx";
import RaindropTitle from "../raindrop-title/raindrop-title.tsx";
import { Size } from "../../logic/enums.ts";
import FlexRow from "../flex-row/flex-row.tsx";
import Spacer from "../spacer/spacer.js";

const RaindropTopBar = ({ streak = null, isFluid = false }) => {
  let tailwindPaddingX = "px-4";

  if (isFluid) {
    tailwindPaddingX = "";
  }

  return (
    <FlexRow className={`py-2 ${tailwindPaddingX}`}>
      <RaindropTitle size={Size.Small} />

      <FlexRow tailwindGap="gap-0">
        <Spacer />
        <div className="px-3">
          <StreakDisplay streak={streak} size={Size.Small} />
        </div>

        <RaindropButton
          icon="fa-bell"
          to={"/raindrop/notifications"}
          style={ButtonStyle.Icon}
        />
        <RaindropButton
          icon="fa-cog"
          to={"/raindrop/settings"}
          style={ButtonStyle.Icon}
        />
      </FlexRow>
    </FlexRow>
  );
};

export default RaindropTopBar;
